import { useEffect, useState } from "react";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import AOS from "aos";
import "aos/dist/aos.css";
import { useNavigate } from "react-router-dom";

import aboutHero from "../../assets/villa16.jpeg";

import villa1 from "../../assets/villa12.jpeg";
import villa2 from "../../assets/villa10.jpeg";

import {
    FaTv,
    FaWineBottle,
    FaWifi,
    FaCoffee,
    FaLock,
    FaBath,
} from "react-icons/fa";
import { GiSlippers } from "react-icons/gi";
import { MdForest } from "react-icons/md";

function SingleRoomVilla() {

    const navigate = useNavigate();

    // Images for retreat slider
    const retreatImages = [
        aboutHero,
        villa1,
        villa2,
    ];

    const [currentSlide, setCurrentSlide] = useState(0);

    // Manual navigation (FIXED)
    const prevSlide = () => {
        setCurrentSlide((prev) =>
            prev === 0 ? retreatImages.length - 1 : prev - 1
        );
    };

    const nextSlide = () => {
        setCurrentSlide((prev) =>
            prev === retreatImages.length - 1 ? 0 : prev + 1
        );
    };

    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentSlide((prev) =>
                prev === retreatImages.length - 1 ? 0 : prev + 1
            );
        }, 4000); // change slide every 4 seconds

        return () => clearInterval(interval);
    }, [retreatImages.length]);

    useEffect(() => {
        AOS.init({ duration: 900, once: true });
    }, []);

    return (
        <div className="w-full overflow-hidden">

            {/* ================= HERO SECTION ================= */}
            <section className="relative h-[60vh] w-full">
                <img
                    src={aboutHero}
                    alt="Gallery Hero"
                    className="absolute inset-0 w-full h-full object-cover"
                />
                <div className="absolute inset-0 bg-black/60" />
                <div className="relative z-10 flex h-full flex-col items-center justify-center text-center text-white px-4">
                    <h1
                        data-aos="fade-up"
                        className="text-4xl border border-[#c97b3a] bg-black/40 backdrop-blur-sm p-6 sm:p-5 sm:text-3xl md:text-4xl font-bold mb-3"
                    >
                        Single Room Villa
                    </h1>
                </div>
            </section>

            {/* ================= SINGLE ROOM VILLA DETAILS ================= */}
            <section className="bg-[#f4f1ed] py-20 px-6">

                {/* Heading */}
                <div className="max-w-4xl mx-auto text-center mb-16">

                    <h2 className="text-4xl md:text-5xl font-serif text-gray-800 mb-6">
                        Single Room Villa (For Couples)
                    </h2>

                    <p className="text-gray-600 leading-relaxed text-sm md:text-base">
                        Discover a romantic hideaway beneath Sigiriya Rock, designed exclusively for couples seeking privacy,
                        comfort, and unforgettable moments surrounded by nature.
                    </p>
                </div>

                {/* Facilities with Icons */}
                <div className="max-w-5xl mx-auto grid grid-cols-2 md:grid-cols-4 gap-y-10 gap-x-6 text-center text-gray-700 mb-20">

                    <div className="flex flex-col items-center space-y-3">
                        <FaTv className="text-[#b58b67] text-3xl" />
                        <p>Satellite TV</p>
                    </div>

                    <div className="flex flex-col items-center space-y-3">
                        <FaWineBottle className="text-[#b58b67] text-3xl" />
                        <p>Mini Bar</p>
                    </div>

                    <div className="flex flex-col items-center space-y-3">
                        <FaWifi className="text-[#b58b67] text-3xl" />
                        <p>Free Wi-Fi</p>
                    </div>

                    <div className="flex flex-col items-center space-y-3">
                        <FaCoffee className="text-[#b58b67] text-3xl" />
                        <p>Tea / Coffee</p>
                    </div>

                    <div className="flex flex-col items-center space-y-3">
                        <FaLock className="text-[#b58b67] text-3xl" />
                        <p>Personal Safe</p>
                    </div>

                    <div className="flex flex-col items-center space-y-3">
                        <FaBath className="text-[#b58b67] text-3xl" />
                        <p>Luxury Bathroom</p>
                    </div>

                    <div className="flex flex-col items-center space-y-3">
                        <GiSlippers className="text-[#b58b67] text-3xl" />
                        <p>Slippers</p>
                    </div>

                    <div className="flex flex-col items-center space-y-3">
                        <MdForest className="text-[#b58b67] text-3xl" />
                        <p>Garden View</p>
                    </div>

                </div>

                {/* Image + Details Section */}
                <div className="max-w-6xl mx-auto grid md:grid-cols-2">

                    {/* Left Image */}
                    <div>
                        <img
                            src={aboutHero}
                            alt="Single Room Villa Interior"
                            className="w-full h-full object-cover"
                        />
                    </div>

                    {/* Right Teal Box */}
                    <div className="bg-[#1f4b4d] text-white p-12 md:p-16 flex flex-col justify-center">

                        <h3 className="text-2xl md:text-3xl font-serif mb-8">
                            The villa is equipped with,
                        </h3>

                        <ul className="space-y-4 text-sm md:text-base">
                            <li>• One Spacious Bedroom</li>
                            <li>• 750 sq. ft. Floor Area</li>
                            <li>• Private Terrace</li>
                            <li>• Romantic Bathtub</li>
                            <li>• Pool & Garden View</li>
                            <li>• Ideal for 2 Adults</li>
                        </ul>

                    </div>
                </div>

            </section>

            {/* ================= DISCOVER YOUR IDEAL RETREAT ================= */}
            <section className="bg-[#e9e6e2] py-20 px-6 relative">

                {/* Heading */}
                <div className="text-center mb-14">
                    <h2 className="text-3xl md:text-5xl font-serif text-gray-800">
                        Discover Your Ideal Retreat
                    </h2>
                </div>

                {/* Slider */}
                <div className="relative max-w-6xl mx-auto">

                    {/* Image */}
                    <img
                        src={retreatImages[currentSlide]}
                        alt="Villa Retreat"
                        className="w-full h-[250px] md:h-[550px] object-cover transition-all duration-700"
                    />

                    {/* Left Arrow */}
                    <button
                        onClick={prevSlide}
                        className="absolute -left-16 top-1/2 -translate-y-1/2 bg-white/70 hover:bg-white p-3 rounded-full shadow"
                    >
                        <FaChevronLeft />
                    </button>

                    {/* Right Arrow */}
                    <button
                        onClick={nextSlide}
                        className="absolute -right-16 top-1/2 -translate-y-1/2 bg-white/70 hover:bg-white p-3 rounded-full shadow"
                    >
                        <FaChevronRight />
                    </button>
                </div>

                {/* Button */}
                <div className="text-center mt-12">
                    <button
                        onClick={() => navigate("/book-now")}
                        className="bg-[#b58b67] text-white px-8 py-3 text-sm tracking-wider hover:bg-[#a47652] transition">
                        BOOK YOUR STAY
                    </button>
                </div>

            </section>

            {/* ================= WHATSAPP FLOAT BUTTON ================= */}
            <a
                href="https://wa.me/94764806045?text=I%20saw%20your%20website.%20Can%20you%20give%20me%20information%20regarding%20your%20villa."
                target="_blank"
                rel="noopener noreferrer"
                className="fixed bottom-5 right-5 z-50"
            >
                <img
                    src="https://upload.wikimedia.org/wikipedia/commons/thumb/6/6b/WhatsApp.svg/512px-WhatsApp.svg.png"
                    alt="WhatsApp"
                    className="h-12 w-12 sm:h-14 sm:w-14 rounded-full shadow-lg transition hover:scale-110"
                />
            </a>

        </div>
    );
}

export default SingleRoomVilla;